// Status
import {roles} from "../../../../index";

export const EMY_PROJECT_STATUSES = {
  UNDER_REVIEW: {
    key: 'UNDER_REVIEW',
    className: 'light-info'
  },
  ACCEPTED: {
    key: 'ACCEPTED',
    className: 'light-primary'
  },
  REJECTED: {
    key: 'REJECTED',
    className: 'light-dark'
  },
}
export const getStatuses = (role) => {
  // Todo ROLES?
  return Object.values(EMY_PROJECT_STATUSES)
}
export const getStatusesKeys = (role) => {
  // Todo ROLES?
  return getStatuses(role).map(v => v.key)
}
export const isReviewed = entity => entity.status !== EMY_PROJECT_STATUSES.UNDER_REVIEW.key
export const PROPOSAL_STATUSES = {
  PENDING: {
    key: 'PENDING',
    className: 'default',
    allowed: ['REJECTED', 'ON_GOING'],
    roles: [roles.client]
  },
  REJECTED: {
    key: 'REJECTED',
    className: 'danger',
    allowed: [],
    roles: [roles.client]
  },
  ON_GOING: {
    key: 'ON_GOING',
    className: 'light-info',
    allowed: ['ON_HOLD', 'COMPLETED', 'CANCELLED', 'ON_HOLD'],
    roles: [roles.client]
  },
  ON_HOLD: {
    key: 'ON_HOLD',
    className: 'light-warning',
    allowed: ['COMPLETED', 'CANCELLED'],
    roles: [roles.super_admin]
  },
  COMPLETED: {
    key: 'COMPLETED',
    className: 'primary',
    allowed: ['ON_HOLD'],
    roles: [roles.provider, roles.client, roles.super_admin] // ?
  },
  CANCELLED: {
    key: 'CANCELLED',
    className: 'light-dark',
    allowed: ['ON_HOLD'],
    roles: [roles.provider, roles.client, roles.super_admin] // ?
  },
}
export const getProposalStatus = (key) => {
  return PROPOSAL_STATUSES[key]
}
export const getProposalStatuses = (role) => {
  return Object.values(PROPOSAL_STATUSES)
}
export const getProposalStatusesKeys = (role) => {
  return getProposalStatuses(role).map(v => v.key)
}